<div class="inner-content">
  <main class="modal-ins-wrapper">
    <div class="ion-text-right">
      <ion-button fill="clear" class="close-modal-button" slot="end" (click)="closeModal()" id="closeButton">
        <ion-icon name="wg-outline-multiply"></ion-icon>
      </ion-button>
    </div>
    <ion-grid>
      <div class="alert-wrapper">
        <div>
          <app-disk-space-alert #diskSpaceAlert></app-disk-space-alert>
        </div>
      </div>

      <ion-slides
        class="slider"
        #slider
        [options]="slideOpts"
        [pager]="this.question.questionInstructions.length > 1"
        *ngIf="question.questionInstructions.length"
        (ionSlideWillChange)="doCheck()"
      >
        <ion-slide *ngFor="let instruction of question.questionInstructions" class="slider__slide">
          <div class="slider__instruction" *ngIf="instruction.instructions">
            <app-html-viewer [html]="instruction.instructions"></app-html-viewer>
          </div>
        </ion-slide>
      </ion-slides>
      <ion-row *ngIf="question.questionInstructions.length > 1" class="mt-auto">
        <ion-col [hidden]="isFirstSlide">
          <ion-button (click)="swipePrevious()" expand="block" color="primary" class="wg-btn-small wg-btn-prev" id="previousButton">
            {{'CommonTexts.prev' | translate}}
          </ion-button>
        </ion-col>
        <ion-col [hidden]="isLastSlide">
          <ion-button (click)="swipeNext()" expand="block" color="primary" class="wg-btn-small wg-btn-next" id="nextButton">
            {{'CommonTexts.next' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="isLastSlide" class="mt-auto">
        <ion-col size="12">
          <ion-button
            id="start-recording-btn"
            color="primary"
            class="wg-btn-small"
            expand="block"
            (click)="actionBtn()"
            [class.wg-btn-disabled]="isLowDiskSpace()"
            [disabled]="isLowDiskSpace()"
          >
            <span *ngIf="question.type === QuestionTypes.VideoQuestion" class="icon-text"
              >{{'ViewInstructions.startRecording' | translate}}</span
            >
            <span *ngIf="question.type === QuestionTypes.PhotoQuestion" class="icon-text"
              >{{'ViewInstructions.takePhoto' | translate}}</span
            >
          </ion-button>
        </ion-col>
        <ion-col size="12" class="d-flex">
          <app-upload-instead-link
            [question]="question"
            class="ml-auto mr-auto"
            (linkClick)="closeModal()"
            [openDelayTime]="500"
            [disabled]="isLowDiskSpace()"
          ></app-upload-instead-link>
        </ion-col>
      </ion-row>
    </ion-grid>
  </main>
</div>
